// Tour visit reporting for the AI widget's tour-history feature.
//
// When the viewer can identify the visitor — an `esv` token from a tracked
// link sent by the AI (SMS/WhatsApp), or the `es360_phone` cookie set after an
// avatar lead capture — it reports the view to the avatar backend so the AI
// can later recall "you viewed the London Eye tour yesterday" on any channel.
// Anonymous visitors are not tracked.

import { getAvatarDomain, avatarHeaders } from 'a_common-folder/utils/avatar';
import { getPathId } from './helpers/common';

const LS_KEY = 'es360_esv';

function getCookie(name) {
    const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
}

export default class VisitTracker {
    constructor(urlParams) {
        this._start = Date.now();
        this._rooms = new Set();
        this._sentEngagement = false;
        this._token = (urlParams && urlParams.esv) || null;
        try {
            if (this._token) {
                localStorage.setItem(LS_KEY, this._token);
            } else {
                this._token = localStorage.getItem(LS_KEY);
            }
        } catch (e) { /* storage unavailable (private mode) */ }
        this._phone = getCookie('es360_phone');
        this._endpoint = `https://${getAvatarDomain()}/api/widget/tour-visit`;
    }

    get identified() {
        return !!(this._token || this._phone);
    }

    start() {
        if (!this.identified) return;
        this._post({ event: 'view' });
        window.addEventListener('pagehide', () => this._engagement());
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') this._engagement();
        });
    }

    roomChange(sceneID) {
        if (sceneID !== undefined && sceneID !== null) this._rooms.add(String(sceneID));
    }

    _payload(extra) {
        const p = {
            tour_id: getPathId(),
            tour_url: window.location.origin + window.location.pathname,
        };
        if (this._token) p.token = this._token;
        if (this._phone) p.phone = this._phone;
        return Object.assign(p, extra);
    }

    _post(extra) {
        try {
            fetch(this._endpoint, {
                method: 'POST',
                headers: avatarHeaders({ 'Content-Type': 'application/json' }),
                body: JSON.stringify(this._payload(extra)),
                keepalive: true,
            }).catch(() => {});
        } catch (e) { /* noop — tracking must never break the viewer */ }
    }

    _engagement() {
        if (!this.identified || this._sentEngagement) return;
        this._sentEngagement = true;
        this._post({
            event: 'engagement',
            rooms: this._rooms.size,
            duration_s: Math.round((Date.now() - this._start) / 1000),
        });
    }
}
